import React from "react";
import { Container, Typography, Box } from "@mui/material";

const TermsOfUse = () => {
  return (
    <Container
      maxWidth="100vw"
      sx={{
        background: "linear-gradient(to right, #001f3f, #003366, #004080)",
      }}
    >
      <Box sx={{ py: 4 }}>
        <Typography
          variant="h6"
          sx={{ fontSize: "1.75rem", color: "white" }}
          fontWeight="bold"
          align="center"
          gutterBottom
        >
          Terms of Use
        </Typography>

        <Typography variant="body1" sx={{ mb: 4, color: "white" }}>
          Please read these terms and conditions carefully before using our
          services.
        </Typography>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
        >
          1. This Agreement and Your Acceptance
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: "white" }}>
          Our Services are owned, operated and provided by Sunratna Business
          Consultancy Pvt Ltd & Parivikshak. Our Services are hosted on servers
          located inside India for Indian customers and outside India for
          International Customers. You agree to these Terms by accessing or
          using any of our Services. If you do not agree to be bound by all of
          these Terms, including our Privacy Notice incorporated herein by
          reference, you should not access or use the Services. THIS CONTRACT
          CONTAINS A BINDING ARBITRATION PROVISION WHICH MAY BE ENFORCED BY THE
          PARTIES. This agreement requires the use of binding arbitration on an
          individual basis to resolve disputes, rather than jury trials or class
          actions, and also limits the remedies available to you in the event of
          a dispute.
        </Typography>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
        >
          2. Our Services{" "}
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: "white" }}>
          Our Services are provided for your personal information and
          non-commercial use. The content of our Services is provided for
          general information only. There will be occasions our Services may be
          interrupted due to scheduled maintenance or upgrades, emergency
          repairs, failure of telecommunications links and/or equipment, or
          similar occurrences. Our Services contain text, software, images,
          photographs, graphics, audio, video, applications, user interfaces,
          visual interfaces, logos, designs, product names, and technical
          specifications (“Materials”) which are derived in whole or in part
          from information and materials supplied by us and other sources, and
          are protected by, copyright, trademark, patent, and other applicable
          laws. Trademarks, logos, and service marks displayed in our Services
          are registered and unregistered trademarks of SBSPL & Parivikshak, its
          subsidiaries and affiliated companies, its licensors or content
          providers, or other third parties. All of these trademarks, logos, and
          service marks are the property of their respective owners. Nothing in
          our Services shall be constructed as granting any license or right to
          use any trademark, logo, or service mark displayed without the owner’s
          prior written permission. The use of any such Materials on any other
          website or networked computer or environment without our express
          written consent is prohibited. Materials may not be copied,
          reproduced, republished, modified, uploaded, posted, transmitted or
          distributed in any way nor may they be decompiled, reverse engineered
          or disassembled, except that you may download one copy of the Material
          on any single computer for your personal, non-commercial use, provided
          you keep intact all copyright, trademark and other proprietary notices
          and make no change in or deletion of author attribution. This limited
          authorization is not a transfer of title in the Materials, and, by
          your use of our Services, you acknowledge that you do not acquire any
          license, ownership or other rights in or to the Materials.
        </Typography>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
        >
          3. Third-Party Content and Linked Sites
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: "white" }}>
          When using our Services, you may be exposed to User Submissions
          submitted, posted or displayed by users from a variety of sources. We
          are not responsible for the accuracy, usefulness, safety, or
          intellectual property rights relating to such user posted content. You
          agree to waive any legal or equitable rights or remedies you have or
          may have against us with respect to the User Submissions of others to
          the fullest extent permitted by law. We may provide links to other
          independent third-party websites (“Linked Sites”) as a convenience to
          you. If you use these links, you do so at your own risk. We have no
          control over, and assume no responsibility for, the content, services,
          privacy policies, Terms of use, or practices of any third-party
          websites. Inclusion of such content and links does not imply our
          sponsorship or endorsement of the same (including the information or
          materials appearing or any of products and services described on
          Linked Sites), our affiliation or association with any such content
          and links, or that any Linked Site is authorized to use any trademark,
          trade name, logo, or copyright of SBSPL & Parivikshak, its
          subsidiaries or affiliates. We will not be a party to or in any way be
          responsible for monitoring any transaction between you and third-party
          providers of products or services. Your correspondence and business
          dealings with third parties found through our Services are solely
          between you and the third party.
        </Typography>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
        >
          4. Limitation of Liability
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: "white" }}>
          You agree that you assume full responsibility for your use of our
          Services and that SBSPL & Zenigma Labs’s liability to you and any
          party is limited as follows. Under no circumstances will we, our
          suppliers or other third parties mentioned or involved in creating,
          producing, or delivering our Services be liable for any direct,
          incidental, consequential, indirect, special or punitive damages
          whatsoever (including without limitation, costs and expenses of any
          type incurred, lost profits, lost data or programs, and business
          interruption) arising out of your access to, use of, inability to use
          or the results of use of our Services, or any Materials contained in
          any or all such Services (including without limitation, those caused
          by or resulting from a failure of performance; error; omission;
          linking to Linked Sites; interruption; deletion; defect; delay in
          operation or transmission; computer virus; communication line failure;
          or destruction of, unauthorized access to, alteration of, or use of
          any computer or system), whether based on warranty, contract, tort,
          negligence, strict liability, or any other legal theory and whether or
          not we were advised of the possibility of such damages. We shall have
          no liability or responsibility for any acts, omissions, or conduct of
          any user or third party, including User Submissions and Linked Sites.
          The maximum total liability of SBSPL & Parivikshak and its
          subsidiaries, affiliates and our officers, directors, shareholders,
          predecessors, successors in interest, employees, and agents, to you
          for any claim under these Terms, whether in contract, tort, or
          otherwise, is one thousand rupees (Rs.1,000). If you are dissatisfied
          with any of the Materials contained in our Services, or with any of
          these Terms, your sole and exclusive remedy is to discontinue
          accessing and using our Services.
        </Typography>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
        >
          5. Changes to our Terms and Termination of the Services
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: "white" }}>
          We reserve the right, in our sole discretion, to revise these Terms at
          any time and correct any errors or omissions in any portion of our
          Services and Materials, and will post updates to these Terms on this
          webpage with a new effective date. Materials may also be changed,
          modified, added, or removed and updated without notice at any time;
          however, we are under no obligation to update Materials. We may also
          make changes in the products, services, programs, or prices (if any)
          described in our Services at any time without notice. Your continued
          use of our Services after any change we make to our Services will be
          considered acceptance of those changes. You should revisit these Terms
          from time to time to review the then-current Terms because your use of
          our Services will be governed by the then-current Terms and Privacy
          Notice.
        </Typography>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
        >
          6. Privacy
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: "white" }}>
          YOUR PRIVACY IS EXTREMELY IMPORTANT TO US. UPON ACCEPTANCE OF THESE
          Terms of USE YOU CONFIRM THAT YOU HAVE READ, UNDERSTOOD AND
          UNEQUIVOCALLY ACCEPTED OUR POLICIES, INCLUDING THE PROVISIONS OF OUR
          PRIVACY POLICY. You may address any complaints or discrepancies in
          relation to the processing (including storing and using) of your
          Personal Information (including Sensitive Personal Information) to:
          GRIEVANCE OFFICER: Mr. XXXX E-MAIL: contact@zenigmalabs.com
        </Typography>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
        >
          7. Governing Law and Jurisdiction
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: "white" }}>
          Any dispute, claim or controversy arising out of, or relating to the
          breach, termination, enforcement, interpretation or validity thereof,
          including the determination of the scope or applicability of these
          Terms of Use, or to your use of the Application or the Service or
          information to which it gives access, shall be determined by
          arbitration in India, before a sole arbitrator. Arbitration shall be
          conducted in accordance with the Arbitration and Conciliation Act,
          1996. The seat of such arbitration shall be Belagavi, Karnataka,
          India. All proceedings of such arbitration, including, without
          limitation, any awards, shall be in the English language. The award
          shall be final and binding on the parties.
        </Typography>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
        >
          8. Severability
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: "white" }}>
          If any provision of these Terms of Use is held by a court of competent
          jurisdiction or arbitral tribunal to be unenforceable under applicable
          law, then such provision shall be excluded from these Terms of Use and
          the remainder of these Terms of Use shall be interpreted as if such
          provision were so excluded and shall be enforceable in accordance with
          its terms; provided however that, in such event these Terms of Use
          shall be interpreted so as to give effect, to the greatest extent
          consistent with and permitted by applicable law, to the meaning and
          intention of the excluded provision as determined by such court of
          competent jurisdiction or arbitral tribunal.
        </Typography>

        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{ fontSize: "1.55rem", color: "white" }}
        >
          9. Contact Us
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: "white" }}>
          If you have any questions about the Terms, please write to us by mail
          at contact@zenigmalabs.com
        </Typography>

        {/* Add more sections as needed */}
      </Box>
    </Container>
  );
};

export default TermsOfUse;
